import { Component, OnInit, Input, Output, EventEmitter, OnChanges, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { take } from 'rxjs';
import { RequestAmountRange } from '@app/shared/models';
import { InlineAlertTypes } from '@app/shared/types/inline-alert-types';
import { UtilsService } from '@app/core/services';
import { CommonModule, CurrencyPipe, DecimalPipe } from '@angular/common';
import { InlineAlertComponent } from '../../inline-alert/inline-alert.component';

@Component({
    selector: 'tc-request-amount-range-alert',
    imports: [
        CommonModule,
        InlineAlertComponent
    ],
    templateUrl: './request-amount-range-alert.component.html',
    styleUrls: ['./request-amount-range-alert.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [DecimalPipe, CurrencyPipe]
})
export class RequestAmountRangeAlertComponent implements OnInit, OnChanges {
  @Output() amountIsCorrectEmit = new EventEmitter<boolean>();
  @Input() amountRange: RequestAmountRange;
  @Input() truncAmount: boolean = false;

  alertText: string;

  inlineAlertTypes = InlineAlertTypes;

  constructor(
    private translateService: TranslateService,
    private utilsService: UtilsService,
    private decimal: DecimalPipe,
    private currency: CurrencyPipe,
  ) { }

  ngOnInit() {
    this.checkMinOrder();
  }

  ngOnChanges(): void {
    this.checkMinOrder();
  }

  private checkMinOrder(): void {
    if (this.amountRange.amount !== null && this.amountRange.minAmount > this.amountRange.amount) {
      const prec = this.amountRange.precision ?? 0;
      const digits = `1.${prec}-${prec}`;

      const min = this.truncAmount
        ? this.utilsService.normalizeAmount(this.amountRange.minAmount, prec)
        : this.amountRange.minAmount;

      const formatted = this.decimal.transform(min);

      const value = `${formatted} ${this.amountRange.currencyCode}`;
      this.translateService.get('REQUEST.ALERT.MIN_ORDER', { value })
        .pipe(take(1))
        .subscribe(res => this.alertText = res);

      this.amountIsCorrectEmit.emit(false);
    } else {
      this.checkMaxOrder();
    }
  }

  private checkMaxOrder(): void {
    if (this.amountRange.maxAmount > 0 &&
      this.amountRange.amount !== null &&
      this.amountRange.maxAmount < this.amountRange.amount) {

      const prec = this.amountRange.precision ?? 0;
      const digits = `1.${prec}-${prec}`;

      const max = this.truncAmount
        ? this.utilsService.normalizeAmount(this.amountRange.maxAmount, prec)
        : this.amountRange.maxAmount;

      const formatted = this.decimal.transform(max);
      const value = `${formatted} ${this.amountRange.currencyCode}`;

      this.translateService.get('REQUEST.ALERT.MAX_ORDER', { value })
        .pipe(take(1))
        .subscribe(res => this.alertText = res);

      this.amountIsCorrectEmit.emit(false);
    } else {
      this.alertText = '';
      this.amountIsCorrectEmit.emit(true);
    }
  }

}
